/* esm.sh - zod@4.4.3/v4/classic/external */
export * from "/*zod@4.4.3/esnext/v4/classic/external.mjs";
